































import {Component, Prop, Vue} from "vue-property-decorator";
import Player from "@/components/Player.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue"
import {PlayerConfig} from "@/interfaces/player.interface";

@Component({
  components: {
    Player,
    LoadingSpinner
  }
})

export default class FilmBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  ignorePageMarginBreakpoint = PlayerConfig.IgnorePageMarginBreakpoints.TABLET;
  ready: boolean = false;

  @Prop() title: string;
  @Prop() director: string;
  @Prop() year: string;

  @Prop() playerSize: number;
  @Prop() hideControls: boolean;
  @Prop() isCalculateWidth: boolean;
  @Prop() selectedKeyword: any;
  @Prop() openFullscreenOnPlay: boolean;
  @Prop() videoUrl: string;
  @Prop() videoInfo: PlayerConfig.IVideoInfo;

  onPlayerReady() {
    this.ready = true;
  }
}
